import "./styles/ScreenDisable.sass";
const ScreenDisable = () => {
  return <div id="screen-disable"></div>;
};

export default ScreenDisable;
